/*
 * @Author: 肖玲
 * @Date: 2023-01-04 10:27:58
 * @LastEditTime: 2023-05-05 15:29:28
 * @LastEditors: 肖玲
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\utils\filter.js
 * 文件备注
 */
import Vue from 'vue'
import store from '@/store/index'

Vue.filter('gender', function (value) {
  const genderList = ['未知', '男', '女']
  return genderList[Number.parseInt(value)]
})

Vue.filter('client_nature', function (value) {
  const natureList = ['自营', '代理']
  return natureList[Number.parseInt(value)]
})

// 终端类型
Vue.filter('client_cls', function (value) {
  const clientClsList = store.state.clientActiveClsList
  return clientClsList[Number.parseInt(value)]
})
// 添加千位符
Vue.filter('addThousandCharacter', function (value) {
  if (!value || value + '' == '' || value == '-') {
    return res
  }
  var res = value.toString().replace(/\d+/, function (n) {
    // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
      return $1 + ','
    })
  })
  return '￥' + res
})

/**
 * 转千分位
 * @param num
 * @returns {string}
 */
Vue.filter('moneyFormat', function (value) {
  let tag = (value || 0).toString().split('.')
  tag[0] = tag[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return tag.join('.')
})
